import React from 'react';
import PropTypes from 'prop-types';

import Card from 'components/Card';
import CustomMap from 'components/CustomMap';
import Field from 'components/Field';
import { LOCATION_TYPE_OPTIONS } from 'enum/location';

const ObjectDescriptors = ({ object }) => {
  const { description, geolocation } = object;
  const location = geolocation ? LOCATION_TYPE_OPTIONS[0].label : LOCATION_TYPE_OPTIONS[1].label;

  return (
    <div className="modal__content padded new-thing-survey">
      <Card header={false}>
        {description && (
          <Field.Group label="Description" full testId="object-description">
            <Field.Text text={description} testId="object-description-value" />
          </Field.Group>
        )}
        <Field.Group label="Location" testId="object-location">
          <Field.Text text={location} testId="object-location-value" />
        </Field.Group>
        {!!geolocation && (
          <>
            <div className="form-row">
              <Field.Group label="Latitude" extraClass="flex-3" testId="object-latitude">
                <Field.Text text={geolocation.latitude} testId="object-latitude-value" />
              </Field.Group>
              <Field.Group label="Longitude" extraClass="flex-2" testId="object-longitude">
                <Field.Text text={geolocation.longitude} testId="object-longitude-value" />
              </Field.Group>
            </div>
            <div data-testid="object-geolocation-map">
              <CustomMap
                center={{
                  lat: geolocation.latitude,
                  lng: geolocation.longitude,
                }}
              />
            </div>
          </>
        )}
      </Card>
    </div>
  );
};

ObjectDescriptors.propTypes = {
  object: PropTypes.object.isRequired,
};

export default ObjectDescriptors;
